import { useLanguage } from "@/contexts/LanguageContext";
import { Globe } from "lucide-react";

// Mali prekidac za jezik — fiksiran gore desno na svakoj stranici.
// Kada je aktivan SR, dugme nudi "EN". Kada je EN, nudi "SR".
export default function LanguageSwitch() {
  const { lang, toggle } = useLanguage();
  const next = lang === "sr" ? "EN" : "SR/HR";

  return (
    <button
      type="button"
      onClick={toggle}
      data-testid="language-switch"
      aria-label={lang === "sr" ? "Switch to English" : "Prebaci na srpski"}
      className="fixed right-4 top-4 z-50 flex items-center gap-1.5 rounded-sm border border-white/15 bg-black/60 px-3 py-2 text-[11px] font-semibold uppercase tracking-[0.2em] text-zinc-200 backdrop-blur-sm transition-all hover:border-[var(--na-green)] hover:text-[var(--na-green)] sm:right-6 sm:top-6"
    >
      <Globe size={13} className="shrink-0" />
      {next}
    </button>
  );
}
